import { render, staticRenderFns } from "./dropdown-user.vue?vue&type=template&id=2b16ac79&"
import script from "./dropdown-user.vue?vue&type=script&lang=js&"
export * from "./dropdown-user.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-user.vue?vue&type=style&index=0&id=2b16ac79&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports